import classNames from "classnames";
import PropTypes from "prop-types";

const ObservationModalGridPanel = ({ divider, scrollable, children }) => {
  return (
    <>
      {divider && <div className="observation-modal-grid-divider" />}
      <div
        className={classNames("observation-modal-grid-panel", {
          "-scrollable": scrollable,
        })}
      >
        {children}
      </div>
    </>
  );
};

ObservationModalGridPanel.propTypes = {
  divider: PropTypes.bool,
  scrollable: PropTypes.bool,
  children: PropTypes.node,
};

export default ObservationModalGridPanel;
